import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CategoryError } from '@/exceptions/category/category.enum';
import { categoryService } from '@/services/category.service';

const useDeleteCategory = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (categoryId: number) =>
			await categoryService.deleteCategory(categoryId),

		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['category'] });
		},

		onError: () => {
			throw new Error(CategoryError.DELETE_ERROR);
		},
	});
};

export default useDeleteCategory;
